import { component } from 'picoapp'
import '@/lib/jquery-global.js';
import marquee from 'jquery.marquee'

export default component((node) => {

    const ticker = node.querySelector('.js-ticker')

    jQuery(ticker).marquee({
        duplicated: true,
        speed: 75
    });

});
